import { createSlice } from '@reduxjs/toolkit';


const initialState = {
  user: {
    _id: null,
    email: null,
    firstName: null,
    lastName: null,
    fullName: null,
    department: null,
    designation: null,
    specialAccess: null,
    clientCode: null,
    clientType: null,
    clientIndustry: null,
    onboarding: null,
    contactEmails: null,
    salesPoc: null,
    addedBy: null,
    cipAccessControl: null,
    crpVersion: null,
    directedTo: null
  },
  isLoggedIn: false,
};

export const sliceName = 'auth'

export const loginAuth = createSlice({
  name: sliceName,
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    setUserCredentials: (state, action) => {
      const { user } = action.payload
      state.user = {
        _id: user._id,
        email: user.email,
        firstName: user.firstName,
        lastName: user.lastName,
        fullName: user.fullName,
        department: user.department,
        designation: user.designation,
        clientCode: user.clientCode,
        clientType: user.clientType,
        clientIndustry: user.clientIndustry,
        onboarding: user.onboarding,
        contactEmails: user.contactEmails,
        salesPoc: user.salesPoc,
        addedBy: user.addedBy,
        specialAccess: null,
        cipAccessControl: user.cipAccessControl,
        crpVersion: user.crpVersion,
        directedTo: user.directedTo
      }
      state.isLoggedIn = true
    },
    resetUserCredentials: (state, action) => {
      return initialState;
    },
    setResendUserEmail: (state, action) => {
      state.user.email = action.payload
    },

  }
});

export const { setUserCredentials, resetUserCredentials, setResendUserEmail} = loginAuth.actions;

export const selectUser = (state) => state[sliceName].user;
export const selectUserRole = (state) => state[sliceName].user.role;
export const selectClientType = (state) => state[sliceName].user.clientType;
export const selectIsUserLoggedIn = (state) => state[sliceName].isLoggedIn;
export const selectSalesPoc = state => state[sliceName].user.salesPoc
export const selectEmail = state => state[sliceName].user.email
export const selectOnboarding = state => state[sliceName].user.onboarding
export const selectScopeOfUser = state => state[sliceName].user.cipAccessControl
export const selectCRPVersion = state => state[sliceName].user.crpVersion
export const selectClientCode = state => state[sliceName].user.clientCode

export default loginAuth.reducer;
